/* SnapFigures-style extras — injected by Claude (theme-only, no paid apps) */
(function () {
  function money(n) { return '$' + Math.round(n); }

  function init() {
    try {
      /* ---------- MARQUEE announcement bar (SAFE targeting) ---------- */
      var welcome = [].slice.call(document.querySelectorAll('.shopify-section-group-header-group *, header *'))
        .find(function (e) { return e.children.length === 0 && /Welcome to our store/i.test(e.textContent.trim()) && e.textContent.trim().length < 60; });
      if (welcome && !welcome.dataset.sfMarquee) {
        /* climb up ONLY while the ancestor still holds just the short announcement text
           (never reach the header section that also contains nav + logo) */
        var bar = welcome;
        while (bar.parentElement &&
               bar.parentElement.textContent.trim().length < 80 &&
               !/header|nav|menu|logo/i.test(bar.parentElement.className || '')) {
          bar = bar.parentElement;
        }
        bar.dataset.sfMarquee = '1';
        bar.style.background = 'linear-gradient(90deg,#8d62e8,#ff6fa5,#58b9ff)';
        bar.style.overflow = 'hidden';
        var msgs = ['🔥 Customers Nationwide 4M+', '🚚 Free Worldwide Shipping Over $79',
          '🎁 Order 2+ items to SAVE 10% — code SAVE10', '⭐ 4.8/5 from 1900+ happy customers'];
        var items = msgs.concat(msgs).map(function (m) { return '<span class="sf-marq-item">' + m + '</span>'; }).join('');
        bar.innerHTML = '<div class="sf-marquee"><div class="sf-marq-track">' + items + '</div></div>';
      }

      var main = document.getElementById('MainContent'); if (!main) return;
      var form = main.querySelector('form[action*="/cart/add"]') || main.querySelector('product-form-component form');
      if (!form) return;

      /* ---------- SAVE badge next to price ---------- */
      function num(el){ if(!el) return 0; var m=(el.textContent||'').replace(',','').match(/[\d.]+/); return m?parseFloat(m[0]):0; }
      function topmost(sel){
        return [].slice.call(main.querySelectorAll(sel))
          .filter(function(e){ var r=e.getBoundingClientRect(); return r.width>0 && r.top<600; })
          .sort(function(a,b){ return a.getBoundingClientRect().top - b.getBoundingClientRect().top; })[0];
      }
      var cmpEl = topmost('.compare-at-price, [class*="compare-at"]');
      var curEl = topmost('.price__regular, .price');
      if (cmpEl && curEl && !document.querySelector('.sf-save-badge')) {
        var save = Math.round(num(cmpEl) - num(curEl));
        if (save > 0) {
          /* insert OUTSIDE the price block (which Horizon re-renders) — after the
             nearest stable price wrapper so the badge survives hydration */
          var priceWrap = cmpEl.closest('.price') || cmpEl.parentNode;
          var b = document.createElement('span'); b.className = 'sf-save-badge'; b.textContent = 'SAVE ' + money(save);
          if (priceWrap.parentNode) { priceWrap.parentNode.insertBefore(b, priceWrap.nextSibling); }
          else { priceWrap.appendChild(b); }
        }
      }

      /* ---------- Move reviews (stars) block ABOVE the product title ---------- */
      (function () {
        var pi = main.querySelector('.product-information') || main;
        var stars = pi.querySelector('.hm-stars'); if (!stars) return;
        var title = [].slice.call(pi.querySelectorAll('.text-block')).find(function (e) {
          var t = (e.textContent || '').trim();
          return e.getBoundingClientRect().height > 0 && /[A-Za-z]{4,}/.test(t) &&
                 t.indexOf('$') === -1 && t.length < 120 && !e.querySelector('.hm-stars');
        });
        if (!title) return;
        var anc = title; while (anc && !anc.contains(stars)) anc = anc.parentElement;
        if (!anc) return;
        function dchild(n) { while (n && n.parentElement !== anc) n = n.parentElement; return n; }
        var tw = dchild(title), sw = dchild(stars);
        if (!tw || !sw || tw === sw) return;
        if (tw.compareDocumentPosition(sw) & Node.DOCUMENT_POSITION_FOLLOWING) {
          anc.insertBefore(sw, tw);
        }
      })();

      /* ---------- Bundle offer box (before variants) ---------- */
      var vp = main.querySelector('variant-picker');
      if (vp && !document.querySelector('.sf-bundle')) {
        var box = document.createElement('div'); box.className = 'sf-bundle';
        var cpy = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>';
        box.innerHTML =
          '<div class="sf-bundle-head"><span>🎁 Special Offer</span><span>Save up to 15%</span></div>' +
          '<div class="sf-bundle-tiers">' +
          '<button type="button" class="sf-tier" data-code="SAVE5"><span class="sf-tier-lbl"><b>Buy 1</b> · <i class="sf-off">5% OFF</i></span><span class="sf-code">SAVE5 ' + cpy + '</span></button>' +
          '<button type="button" class="sf-tier" data-code="SAVE10"><span class="sf-tier-lbl"><b>Buy 2</b> · <i class="sf-off">10% OFF</i></span><span class="sf-code">SAVE10 ' + cpy + '</span></button>' +
          '<button type="button" class="sf-tier" data-code="SAVE15"><span class="sf-tier-lbl"><b>Buy 3</b> · <i class="sf-off">15% OFF</i></span><span class="sf-code">SAVE15 ' + cpy + '</span></button>' +
          '</div>';
        vp.parentNode.insertBefore(box, vp);
        box.addEventListener('click', function (e) {
          var t = e.target.closest('.sf-tier'); if (!t) return;
          var code = t.getAttribute('data-code'); if (!code) return;
          var lbl = t.querySelector('.sf-code'); if (!lbl) return;
          var flash = function () {
            var prev = lbl.innerHTML; t.classList.add('copied'); lbl.textContent = 'Copied!';
            setTimeout(function () { lbl.innerHTML = prev; t.classList.remove('copied'); }, 1200);
          };
          var fb = function () {
            try { var ta = document.createElement('textarea'); ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.focus(); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); } catch (_) {}
            flash();
          };
          if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(flash, fb); } else { fb(); }
        });
      }

      /* ---------- Upload photo box (FUNCTIONAL: attaches to order as file property) ---------- */
      var buy = main.querySelector('.product-form-buttons');
      if (buy && !document.querySelector('.sf-upload')) {
        var up = document.createElement('div'); up.className = 'sf-upload';
        up.innerHTML =
          '<div class="sf-upload-inner"><span class="sf-upload-plus">+</span><span>Upload Your Photo</span></div>' +
          '<input type="file" accept="image/*" class="sf-upload-input" name="properties[Your Photo]">' +
          '<div class="sf-upload-preview" style="display:none"></div>' +
          '<p class="sf-upload-note">Upload a clear photo for your figurine. We craft it by hand and email you a sample before shipping.</p>';
        buy.parentNode.insertBefore(up, buy);
        var inp = up.querySelector('.sf-upload-input');
        var prev = up.querySelector('.sf-upload-preview');
        inp.addEventListener('change', function () {
          if (inp.files && inp.files[0]) {
            var f = inp.files[0];
            prev.style.display = 'block';
            try {
              var url = URL.createObjectURL(f);
              prev.innerHTML = '<img src="' + url + '" style="max-height:90px;border-radius:8px;margin-top:8px">' +
                '<div style="font-size:12px;color:#2c7962;font-weight:700;margin-top:4px">✅ Photo attached: ' + f.name + '</div>';
            } catch (e) { prev.textContent = '✅ Photo attached: ' + f.name; }
          }
        });
      }

      /* ---------- Accordion tabs (after buy buttons, right column) ---------- */
      if (buy && !document.querySelector('.sf-acc')) {
        var acc = document.createElement('div'); acc.className = 'sf-acc';
        var rows = [
          ['Shopping Tips', '<p>For best results, upload a clear, front-facing photo with good lighting. The clearer the photo, the more accurate your figurine.</p>'],
          ['Personalized Customization', '<p>Every figurine is sculpted and hand-painted to match your photo — face, outfit, hair and details. Leave any special requests in the order notes.</p>'],
          ['Shipping & Returns', '<p>Made to order in 5–10 business days, then shipped worldwide with tracking. 30-day satisfaction guarantee.</p>']
        ];
        acc.innerHTML = rows.map(function (r) {
          return '<details class="sf-acc-item"><summary>' + r[0] + '</summary><div class="sf-acc-body">' + r[1] + '</div></details>';
        }).join('');
        buy.parentNode.insertBefore(acc, buy.nextSibling);
      }

      /* ---------- BELOW-FOLD marketing sections (like snapfigures) ---------- */
      var mainEl = document.getElementById('MainContent');
      var prodSection = (main.querySelector('.product-information') || form).closest('[id^="shopify-section"]');
      if (mainEl && prodSection && !document.querySelector('.sf-below')) {
        var below = document.createElement('div'); below.className = 'sf-below';
        var star = '<span class="sf-stars">★★★★★</span>';
        var C = 'https://snapfigures.com';
        var thumbs = [
          '/cdn/shop/files/preview_images/f54458eea62b4a58b8d60aea718077bb.thumbnail.0000000000_900x.jpg',
          '/cdn/shop/files/preview_images/f679abcf3c36416ca3a25f2ce813b6b0.thumbnail.0000000000_900x.jpg',
          '/cdn/shop/files/preview_images/b8be82df7b1e401b93826ac44db28b5e.thumbnail.0000000000_900x.jpg',
          '/cdn/shop/files/preview_images/9951b35290be405c8b6bfa8a4a1199a4.thumbnail.0000000000_900x.jpg'
        ];
        var phones = thumbs.map(function (t, ix) {
          return '<div class="sf-phone" data-vid="' + ix + '"><span class="sf-cpick">Creator Pick</span>' +
            '<img loading="lazy" src="' + C + t + '" alt="Creator video">' +
            '<span class="sf-play">▶</span><span class="sf-handle">@creator ✔</span></div>';
        }).join('');
        below.innerHTML =
          /* Your Photo, Your Figure */
          '<section class="sf-sec sf-yp"><div class="sf-yp-grid">' +
          '<div class="sf-yp-media">' +
          '<img class="sf-yp-hero" loading="lazy" src="' + C + '/cdn/shop/files/43_0247456f-571c-4c01-9ae2-b259b22a7c73.png" alt="Custom figurines">' +
          '<div class="sf-yp-ba"><img loading="lazy" src="' + C + '/cdn/shop/files/custom_2.png" alt="Before"><span class="sf-yp-arrow">→</span><img loading="lazy" src="' + C + '/cdn/shop/files/pet_person.png" alt="After"></div>' +
          '</div>' +
          '<div class="sf-yp-text"><span class="sf-badge">MADE FROM YOUR PHOTO</span>' +
          '<h2 class="sf-h2 sf-left">Your Photo, Your Figure</h2>' +
          '<p class="sf-sub sf-left">Turn a favorite photo into a custom keepsake, refined by artists and ready to gift.</p>' +
          '<div class="sf-yp-feats"><div class="sf-tile">📷 Made from photo</div><div class="sf-tile">🎨 Artist-refined</div><div class="sf-tile">🎁 Gift-ready</div><div class="sf-tile">💎 Premium finish</div></div>' +
          '<a href="#" class="sf-cta">Start Customizing →</a></div>' +
          '</div></section>' +
          /* How it works */
          '<section class="sf-sec sf-how"><h2 class="sf-h2">How It Works</h2>' +
          '<p class="sf-sub">Your photo becomes a one-of-a-kind figurine in 4 easy steps.</p>' +
          '<div class="sf-steps">' +
          '<div class="sf-step"><div class="sf-step-ic">📸</div><h3>1. Upload Your Photo</h3><p>Send us a clear, front-facing photo.</p></div>' +
          '<div class="sf-step"><div class="sf-step-ic">🎨</div><h3>2. Choose Style &amp; Size</h3><p>Pick Chibi, Pixar or Minecraft and your size.</p></div>' +
          '<div class="sf-step"><div class="sf-step-ic">🛠️</div><h3>3. We Handcraft It</h3><p>Sculpted &amp; hand-painted to match your photo.</p></div>' +
          '<div class="sf-step"><div class="sf-step-ic">📦</div><h3>4. Delivered To You</h3><p>Shipped worldwide with tracking.</p></div>' +
          '</div></section>' +
          /* Why choose us */
          '<section class="sf-sec sf-why"><h2 class="sf-h2">Why Customers Love Us</h2>' +
          '<div class="sf-usps">' +
          '<div class="sf-usp"><div class="sf-usp-ic">⭐</div><b>4.8/5 Rating</b><span>From 1,900+ happy customers</span></div>' +
          '<div class="sf-usp"><div class="sf-usp-ic">🚚</div><b>Free Worldwide Shipping</b><span>On all orders over $79</span></div>' +
          '<div class="sf-usp"><div class="sf-usp-ic">🖌️</div><b>Handcrafted &amp; Painted</b><span>Every detail matched by hand</span></div>' +
          '<div class="sf-usp"><div class="sf-usp-ic">💝</div><b>30-Day Guarantee</b><span>Love it or your money back</span></div>' +
          '</div></section>' +
          /* Reviews */
          '<section class="sf-sec sf-reviews"><h2 class="sf-h2">Real Customers, Real Smiles</h2>' + star +
          '<p class="sf-sub">Based on 1,900+ verified reviews</p>' +
          '<div class="sf-cards">' +
          '<div class="sf-card">' + star + '<p>“The likeness is unbelievable — it looks exactly like my husband! Packaging was gorgeous too.”</p><b>Jessica M.</b><span>Verified Buyer</span></div>' +
          '<div class="sf-card">' + star + '<p>“Ordered one of my dog and cried happy tears. Best gift I’ve ever given.”</p><b>Daniel R.</b><span>Verified Buyer</span></div>' +
          '<div class="sf-card">' + star + '<p>“Fast shipping, amazing quality. Already ordered 3 more for the family!”</p><b>Amanda K.</b><span>Verified Buyer</span></div>' +
          '</div></section>' +
          /* A Gift Made From a Real Memory (comparison) */
          '<section class="sf-sec sf-cmp"><span class="sf-badge">WHY MINIMORPH</span>' +
          '<h2 class="sf-h2">A Gift Made From a Real Memory</h2>' +
          '<p class="sf-sub">A simple comparison between a personalized keepsake and an ordinary gift.</p>' +
          '<div class="sf-cmp-grid">' +
          '<div class="sf-cmp-card"><span class="sf-cmp-tag sf-tag-good">MINIMORPH</span>' +
          '<img loading="lazy" src="' + C + '/cdn/shop/files/compare_43_1.png" alt="Custom figure">' +
          '<div class="sf-cmp-body"><h3>Custom Photo Figure</h3><p>Made from a real photo and refined into a keepsake that feels personal, playful, and gift-ready.</p>' +
          '<div class="sf-cmp-feats"><span>✔ Premium Vibrant Resin</span><span>✔ Artist-refined</span><span>✔ Gift-ready</span></div></div></div>' +
          '<div class="sf-vs">VS</div>' +
          '<div class="sf-cmp-card sf-cmp-bad"><span class="sf-cmp-tag sf-tag-bad">ORDINARY GIFT</span>' +
          '<img loading="lazy" src="' + C + '/cdn/shop/files/compare_43_2.png" alt="Generic gift">' +
          '<div class="sf-cmp-body"><h3>Generic Gift</h3><p>A nice present, but usually less personal and easier to forget after the moment passes.</p>' +
          '<div class="sf-cmp-feats sf-feats-bad"><span>· Fragile Plastic &amp; Clay</span><span>· Dull &amp; Uneven Painting</span><span>· No story</span></div></div></div>' +
          '</div>' +
          '<div class="sf-cmp-cta"><span>Made from your photo. Created to keep the moment forever.</span><a href="#" class="sf-cta sf-cta-sm">Start Customizing →</a></div>' +
          '</section>' +
          /* Real Creators. Real Reactions. */
          '<section class="sf-sec sf-cr"><div class="sf-cr-grid">' +
          '<div class="sf-cr-text"><span class="sf-badge">✦ CREATOR VIDEOS ✦</span>' +
          '<h2 class="sf-h2 sf-left">Real Creators.<br>Real Reactions.</h2>' +
          '<p class="sf-sub sf-left">Watch creators turn favorite photos into custom MiniMorph gifts.</p>' +
          '<div class="sf-cr-stats"><div><b>500+</b><span>Creator Videos</span></div><div><b>10M+</b><span>Views</span></div><div><b>4.9★</b><span>Loved Gifts</span></div></div>' +
          '</div>' +
          '<div class="sf-cr-cards">' + phones + '</div>' +
          '</div></section>' +
          /* FAQ */
          '<section class="sf-sec sf-faq2"><h2 class="sf-h2">Frequently Asked Questions</h2><div class="sf-acc">' +
          faqItem('How do I send my photo?', 'Just upload a clear, front-facing photo in the box above during checkout — or send it to us by email/WhatsApp right after ordering.') +
          faqItem('What are the figurines made of?', 'Premium, durable resin, hand-finished and hand-painted for lifelike detail that lasts for years.') +
          faqItem('How long does it take?', 'Each figurine is made to order in 5–10 business days, then shipped worldwide with tracking.') +
          faqItem('Do you ship internationally?', 'Yes! We ship worldwide. Delivery times vary by destination and a tracking number is provided with every order.') +
          faqItem('What is your return policy?', 'We offer a 30-day money-back guarantee. If you are not fully satisfied, contact our support team for a hassle-free return.') +
          '</div></section>';
        prodSection.parentNode.insertBefore(below, prodSection.nextSibling);
        [].slice.call(below.querySelectorAll('.sf-cta')).forEach(function (a) {
          a.addEventListener('click', function (e) { e.preventDefault(); (document.getElementById('MainContent') || document.body).scrollIntoView({ behavior: 'smooth' }); });
        });
        /* click a creator card -> play its video in a lightbox */
        [].slice.call(below.querySelectorAll('.sf-phone')).forEach(function (ph) {
          ph.addEventListener('click', function () {
            var vids = window.SF_VIDEOS || [];
            var url = vids[parseInt(ph.getAttribute('data-vid'), 10)];
            if (!url) return;
            var lb = document.createElement('div'); lb.className = 'sf-lb';
            lb.innerHTML = '<div class="sf-lb-box"><span class="sf-lb-x">&times;</span>' +
              '<video src="' + url + '" controls autoplay playsinline></video></div>';
            document.body.appendChild(lb);
            function close() { var v = lb.querySelector('video'); if (v) { v.pause(); } lb.remove(); }
            lb.addEventListener('click', function (e) { if (e.target === lb || e.target.className === 'sf-lb-x') close(); });
          });
        });
      }
    } catch (e) { if (window.console) console.warn('sf-extras', e); }
  }
  function faqItem(q, a) {
    return '<details class="sf-acc-item"><summary>' + q + '</summary><div class="sf-acc-body"><p>' + a + '</p></div></details>';
  }

  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  [400, 900, 1800, 3000, 5000].forEach(function (t) { setTimeout(init, t); });

  /* keep the injected extras alive if Horizon re-renders the product form */
  var pending = false;
  var mo = new MutationObserver(function () {
    if (pending) return; pending = true;
    setTimeout(function () { pending = false; init(); }, 300);
  });
  function observe() {
    var m = document.getElementById('MainContent');
    if (m) mo.observe(m, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') observe(); else document.addEventListener('DOMContentLoaded', observe);

  /* ============ REQUIRE a customer photo before ordering ============ */
  (function () {
    function uploadInput() { return document.querySelector('form[action*="/cart/add"] input[name="properties[Your Photo]"]'); }
    function needsPhoto() { var fi = uploadInput(); return fi && (!fi.files || fi.files.length === 0); }
    function toast(msg) {
      var t = document.getElementById('sf-need-photo');
      if (!t) { t = document.createElement('div'); t.id = 'sf-need-photo'; document.body.appendChild(t);
        t.style.cssText = 'position:fixed;left:50%;bottom:26px;transform:translateX(-50%);z-index:99999;background:#e11d2a;color:#fff;font-weight:700;font-family:sans-serif;padding:12px 22px;border-radius:999px;box-shadow:0 8px 24px rgba(0,0,0,.25);font-size:14px;opacity:0;transition:opacity .2s;max-width:90vw;text-align:center'; }
      t.textContent = '⚠ ' + msg; t.style.opacity = '1';
      clearTimeout(t._h); t._h = setTimeout(function () { t.style.opacity = '0'; }, 3400);
    }
    function flash() {
      var box = document.querySelector('.sf-upload, #nf-drop, .nf-drop');
      if (box) {
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        box.style.transition = 'box-shadow .2s'; box.style.boxShadow = '0 0 0 3px #ff6fa5';
        try { box.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-7px)' }, { transform: 'translateX(7px)' }, { transform: 'translateX(0)' }], { duration: 320, iterations: 2 }); } catch (e) {}
        setTimeout(function () { box.style.boxShadow = ''; }, 1700);
      }
      toast('Please upload your photo first so we can craft your figurine.');
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[name="add"], button[type="submit"], .add-to-cart-button, [class*="add-to-cart"], .shopify-payment-button__button, [class*="buy-now"], [class*="buy-buttons"] button');
      if (!btn) return;
      if (!uploadInput()) return;            /* only on product pages with the photo field */
      if (needsPhoto()) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); flash(); }
    }, true);
  })();

  /* ============ Show the customer's AI figurine as the CART thumbnail ============ */
  (function () {
    function cartRoot() { return document.querySelector('cart-drawer, #cart-drawer, [id*="cart-drawer"], .cart-drawer, #CartDrawer, .drawer--cart'); }
    function swapCartAI() {
      try {
        var x = new XMLHttpRequest(); x.open('GET', '/cart.js', false); x.send();
        var cart = JSON.parse(x.responseText); var ai = [];
        cart.items.forEach(function (it, i) { var u = it.properties && it.properties._ai_preview; if (u) ai.push({ i: i, key: it.key, url: u }); });
        if (!ai.length) return;
        var scope = cartRoot() || document;
        ai.forEach(function (o) {
          var c = scope.querySelector('[data-key="' + o.key + '"],[data-line-item-key="' + o.key + '"],[data-cart-item-key="' + o.key + '"]');
          if (!c) {
            var items = [].slice.call(scope.querySelectorAll('[class*="cart-item"],[class*="line-item"],.cart__row,li[class*="cart"]'))
              .filter(function (el) { return el.querySelector('img') && el.querySelector('a[href*="/products/"]'); });
            c = items[o.i] || null;
          }
          if (c) { var img = c.querySelector('img'); if (img && img.getAttribute('data-ai') !== o.url) { img.setAttribute('data-ai', o.url); img.setAttribute('src', o.url); img.setAttribute('srcset', o.url); img.removeAttribute('sizes'); img.style.objectFit = 'cover'; } }
        });
      } catch (e) {}
    }
    if (document.readyState !== 'loading') setTimeout(swapCartAI, 700); else document.addEventListener('DOMContentLoaded', function () { setTimeout(swapCartAI, 700); });
    document.addEventListener('click', function () { setTimeout(swapCartAI, 350); setTimeout(swapCartAI, 950); }, true);
    ['cart:refresh', 'cart:updated', 'cart:change', 'on:cart:add', 'on:line-item:change'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(swapCartAI, 150); }); });
    var cmo = new MutationObserver(function () { if (cmo._p) return; cmo._p = true; setTimeout(function () { cmo._p = false; swapCartAI(); }, 250); });
    (function arm() { var r = cartRoot(); if (r) cmo.observe(r, { childList: true, subtree: true }); else setTimeout(arm, 1200); })();
  })();
})();
